export default __webpack_public_path__ + "static/header-logo-cmo-cc525ef0e892d46f7f5f399bbfe49595.png";